import { useState, useEffect, useCallback } from 'react';

export const useTheme = () => {
    const [theme, setTheme] = useState(() => {
        // 1. Check localStorage
        const saved = localStorage.getItem('theme');
        if (saved) return saved;

        // 2. Check time (Auto-schedule: Dark Mode after 7 PM or before 7 AM)
        const hour = new Date().getHours();
        if (hour >= 19 || hour < 7) return 'dark';

        // 3. Fallback to system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }

        return 'light';
    });

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
    }, []);

    return { theme, toggleTheme };
};
